import { render, staticRenderFns } from "./CtaCardFour.vue?vue&type=template&id=79acbb20"
import script from "./CtaCardFour.vue?vue&type=script&lang=js"
export * from "./CtaCardFour.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports